export default __webpack_public_path__ + "75dfef2f12f2b5aeb9d46a19b919e1a9.woff";